import {
  FormControl,
  Grid,
  Typography,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import React from "react";
import { Controller, useWatch } from "react-hook-form";
import { TextField } from "@ofqual/portal-components/components/TextField";

import { SocItem } from "../../domain/SocItem";
import { SectionProps } from "./SectionProps";
import { fieldLabels } from "./fieldLabels";
import { Error } from "../common/Error";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";
import { UserRole } from "../../domain/userRole";

export const GoverningBodySignoff: React.FC<SectionProps<SocItem>> = (
  sectionProps
) => {
  const { control, disabled, errors } = sectionProps;

  const { roles } = useSelector(authSelector);

 const {
   govBodyConfirmCompliance,
   govBodyConfirmApproval,
   govBodyConfirmChairRo,
 } = useWatch<SocItem>({
   control,
   name: [
     "govBodyConfirmCompliance",
     "govBodyConfirmApproval",
     "govBodyConfirmChairRo",
   ],
 });

  console.log ("Errors ", errors)
  console.log(
    "govBodyConfirmCompliance ",
    govBodyConfirmCompliance,
    "govBodyConfirmApproval ",
    govBodyConfirmApproval,
    "govBodyConfirmChairRo ",
    govBodyConfirmChairRo)
  
  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Typography variant="body1">
          Under General Condition B2 for{" "}
          <a href="https://www.gov.uk/guidance/ofqual-handbook/section-b-the-awarding-organisation-and-ofqual">
            Ofqual
          </a>
          ,{" "}
          <a href="https://www.qualificationswales.org/media/5975/standard-conditions-of-recognition.pdf">
            Qualification Wales
          </a>{" "}
          and{" "}
          <a href="https://ccea.org.uk/regulation/information-awarding-organisations/general-conditions-recognition">
            CCEA Regulation
          </a>
          , you must provide an annual Statement of Compliance.
        </Typography>
        <Typography variant="body1">
          The Statement of Compliance must be:
        </Typography>
        <Typography variant="body1">
          (a) made in any form and on any date as may be notified to the
          awarding organisation by Ofqual / Qualifications Wales and CCEA
          Regulation
        </Typography>
        <Typography variant="body1">(b) accurate</Typography>
        <Typography variant="body1">
          (c) formally approved by the Governing Body of the awarding
          organisation, and
        </Typography>
        <Typography variant="body1">
          (d) signed by the chair of the Governing Body and the Responsible
          Officer.
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name="govBodyConfirmCompliance"
          rules={{ validate: (value) => value !== null && value !== undefined }}
          render={(props) => (
            <FormControl component="fieldset" required disabled={disabled}>
              <FormLabel id="govBodyConfirmCompliance-label" component="legend">
                {fieldLabels.govBodyConfirmCompliance}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="govBodyConfirmCompliance-label"
                name="govBodyConfirmCompliance"
                data-test="radiogroup-govBodyConfirmCompliance"
                onChange={(e) => props.onChange(e.target.value === "true")}
              >
                <FormControlLabel
                  value={true}
                  label="Yes"
                  control={<Radio />}
                  data-test="govBodyConfirmCompliance-yes"
                  checked={props.value === true}
                />
                <FormControlLabel
                  value={false}
                  label="No"
                  control={<Radio />}
                  data-test="govBodyConfirmCompliance-no"
                  checked={props.value === false}
                />
              </RadioGroup>
            </FormControl>
          )}
        />
        {errors.govBodyConfirmCompliance && (
          <>
            <br></br>
            <Error data-test="govBodyConfirmCompliance-validation">
              You must select at least one option
            </Error>
          </>
        )}
      </Grid>

      <Grid>
        {govBodyConfirmCompliance === false ? (
          <>
            <Grid item xs={12}>
              <Typography variant="body1">
                You have answered 'no' to say that the content of your Statement
                of Compliance is not accurate. Please provide an explanation
                below. We will contact you to discuss further.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="govBodyNoCompliance"
                rules={{ required: true, maxLength: 5000 }}
                as={
                  <TextField
                    multiline
                    rows={8}
                    required
                    label={fieldLabels.govBodyNoCompliance}
                    readOnly={disabled}
                    data-test="govBodyNoCompliance-field"
                  />
                }
              />
              {errors.govBodyNoCompliance?.type === "required" && (
                <Error data-test="govBodyNoCompliance-validation">
                  This field is required
                </Error>
              )}
              {errors.govBodyNoCompliance?.type === "maxLength" && (
                <Error data-test="govBodyNoCompliance-validation">
                  Must be less than 5,000 characters
                </Error>
              )}
            </Grid>
          </>
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name="govBodyConfirmApproval"
          rules={{ validate: (value) => value !== null && value !== undefined }}
          render={(props) => (
            <FormControl component="fieldset" required disabled={disabled}>
              <FormLabel id="govBodyConfirmApproval-label" component="legend">
                {fieldLabels.govBodyConfirmApproval}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="govBodyConfirmApproval-label"
                name="govBodyConfirmApproval"
                data-test="radiogroup-govBodyConfirmApproval"
                onChange={(e) => props.onChange(e.target.value === "true")}
              >
                <FormControlLabel
                  value={true}
                  label="Yes"
                  control={<Radio />}
                  data-test="govBodyConfirmApproval-yes"
                  checked={props.value === true}
                />
                <FormControlLabel
                  value={false}
                  label="No"
                  control={<Radio />}
                  data-test="govBodyConfirmApproval-no"
                  checked={props.value === false}
                />
              </RadioGroup>
            </FormControl>
          )}
        />
        {errors.govBodyConfirmApproval && (
          <>
            <br></br>
            <Error data-test="govBodyConfirmApproval-validation">
              You must select at least one option
            </Error>
          </>
        )}
      </Grid>
      <Grid>
        {govBodyConfirmApproval === false ? (
          <>
            <Grid item xs={12}>
              <Typography variant="body1">
                You have answered 'no' to say your Governing Body has not
                formally approved the Statement of Compliance submission, or
                that you are unable to produce documents to verify that the
                Statement of Compliance was formally approved by the Governing
                Body. Please provide an explanation below. We will contact you
                to discuss further.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="govBodyConfirmNoApproval"
                rules={{ required: true, maxLength: 5000 }}
                as={
                  <TextField
                    multiline
                    rows={8}
                    required
                    label={fieldLabels.govBodyConfirmNoApproval}
                    readOnly={disabled}
                    data-test="govBodyConfirmNoApproval-field"
                  />
                }
              />
              {errors.govBodyConfirmNoApproval?.type === "required" && (
                <Error data-test="govBodyConfirmNoApproval-validation">
                  This field is required
                </Error>
              )}
              {errors.govBodyConfirmNoApproval?.type === "maxLength" && (
                <Error data-test="govBodyConfirmNoApproval-validation">
                  Must be less than 5,000 characters
                </Error>
              )}
            </Grid>
          </>
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name="govBodyConfirmChairRo"
          rules={{ validate: (value) => value !== null && value !== undefined }}
          render={(props) => (
            <FormControl component="fieldset" required disabled={disabled}>
              <FormLabel id="govBodyConfirmChairRo-label" component="legend">
                {fieldLabels.govBodyConfirmChairRo}
              </FormLabel>
              <RadioGroup
                row
                aria-labelledby="govBodyConfirmChairRo-label"
                name="govBodyConfirmChairRo"
                data-test="radiogroup-govBodyConfirmChairRo"
                onChange={(e) => props.onChange(e.target.value === "true")}
              >
                <FormControlLabel
                  value={true}
                  label="Yes"
                  control={<Radio />}
                  data-test="govBodyConfirmChairRo-yes"
                  checked={props.value === true}
                />
                <FormControlLabel
                  value={false}
                  label="No"
                  control={<Radio />}
                  data-test="govBodyConfirmChairRo-no"
                  checked={props.value === false}
                />
              </RadioGroup>
            </FormControl>
          )}
        />
        {errors.govBodyConfirmChairRo && (
          <>
            <br></br>
            <Error data-test="govBodyConfirmChairRo-validation">
              You must select at least one option
            </Error>
          </>
        )}
      </Grid>

      <Grid>
        {govBodyConfirmChairRo === false ? (
          <>
            <Grid item xs={12}>
              <Typography variant="body1">
                You answered 'no' to say your Chair of the Governing Body and/or
                the Responsible Officer have not signed off the Statement of
                Compliance submission, or that you are not able to produce
                documents to verify the Statement of Compliance was signed by
                the chair of the Governing Body and the Responsible Officer.
                Please provide an explanation below. We will
                contact you to discuss further.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Controller
                control={control}
                name="govBodyConfirmNoChairRo"
                rules={{ required: true, maxLength: 5000 }}
                as={
                  <TextField
                    multiline
                    rows={8}
                    required
                    label={fieldLabels.govBodyConfirmNoChairRo}
                    readOnly={disabled}
                    data-test="govBodyConfirmNoChairRo-field"
                  />
                }
              />
              {errors.govBodyConfirmNoChairRo?.type === "required" && (
                <Error data-test="govBodyConfirmNoChairRo-validation">
                  This field is required
                </Error>
              )}
              {errors.govBodyConfirmNoChairRo?.type === "maxLength" && (
                <Error data-test="govBodyConfirmNoChairRo-validation">
                  Must be less than 5,000 characters
                </Error>
              )}
            </Grid>
          </>
        ) : null}
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name="govBodyConfirmNameRo"
          rules={{ required: true, maxLength: 255 }}
          as={
            <TextField
              required
              label={fieldLabels.govBodyConfirmNameRo}
              readOnly={disabled}
              data-test="govBodyConfirmNameRo-field"
            />
          }
        />
        {errors.govBodyConfirmNameRo?.type === "required" && (
          <Error data-test="govBodyConfirmNameRo-validation">
            This field is required
          </Error>
        )}
        {errors.govBodyConfirmNoChairRo?.type === "maxLength" && (
          <Error data-test="govBodyConfirmNameRo-validation">
            Must be less than 255 characters
          </Error>
        )}
      </Grid>

      <Grid item xs={12}>
        <Controller
          control={control}
          name="govBodyConfirmNameChair"
          rules={{ required: true, maxLength: 255 }}
          as={
            <TextField
              required
              label={fieldLabels.govBodyConfirmNameChair}
              readOnly={disabled}
              data-test="govBodyConfirmNameChair-field"
            />
          }
        />
        {errors.govBodyConfirmNameChair?.type === "required" && (
          <Error data-test="govBodyConfirmNameChair-validation">
            This field is required
          </Error>
        )}
        {errors.govBodyConfirmNameChair?.type === "maxLength" && (
          <Error data-test="govBodyConfirmNameChair-validation">
            Must be less than 255 characters
          </Error>
        )}
      </Grid>

      {!roles.includes(UserRole.AoResponsibleOfficer) ? (
        <Grid item xs={12}>
          <Controller
            control={control}
            name="govBodyConfirmSigningOnBehalfName"
            rules={{ required: true, maxLength: 255 }}
            as={
              <TextField
                required
                label={fieldLabels.govBodyConfirmSigningOnBehalfName}
                readOnly={disabled}
                data-test="govBodyConfirmSigningOnBehalfName-field"
              />
            }
          />
          {errors.govBodyConfirmSigningOnBehalfName?.type === "required" && (
            <Error data-test="govBodyConfirmSigningOnBehalfName-validation">
              This field is required
            </Error>
          )}
          {errors.govBodyConfirmSigningOnBehalfName?.type === "maxLength" && (
            <Error data-test="govBodyConfirmSigningOnBehalfName-validation">
              Must be less than 255 characters
            </Error>
          )}
        </Grid>
      ) : null}

      {!roles.includes(UserRole.AoResponsibleOfficer) ? (
        <Grid item xs={12}>
          <Controller
            control={control}
            name="govBodyConfirmSigningOnBehalfTitle"
            rules={{ required: true, maxLength: 255 }}
            as={
              <TextField
                required
                label={fieldLabels.govBodyConfirmSigningOnBehalfTitle}
                readOnly={disabled}
                data-test="govBodyConfirmSigningOnBehalfTitle-field"
              />
            }
          />
          {errors.govBodyConfirmSigningOnBehalfTitle?.type === "required" && (
            <Error data-test="govBodyConfirmSigningOnBehalfTitle-validation">
              This field is required
            </Error>
          )}
          {errors.govBodyConfirmSigningOnBehalfName?.type === "maxLength" && (
            <Error data-test="govBodyConfirmSigningOnBehalfTitle-validation">
              Must be less than 255 characters
            </Error>
          )}
        </Grid>
      ) : null}
    </Grid>
  );
};
